import React from 'react';
import { Button } from '@material-tailwind/react';
import { clsx } from 'clsx';
import { ReactComponent as LeftIcon } from '@assets/images/left_icon.svg';
import { ReactComponent as SuccessIcon } from '@assets/icons/Success.svg';
import { ReactComponent as InfoErrorIcon } from '@assets/icons/info_error_icon.svg';


/**
 * Returns a Button component with label, icon and custom onClick/color/state for document type
 * @param {Object} args
 * @param {string} args.label - Button label text
 * @param {Function} args.onClick - onClick handler for the button
 * @param {boolean} args.isHidden - Whether the button is hidden (hide if true)
 * @param {React.ReactNode} args.icon - Icon component to display left of label
 * @param {boolean} args.hasError - Whether the document needs resubmission (error icon if true)
 * @param {boolean} args.isSuccess - Whether the document is successful
 * @returns {React.ReactNode|null}
 */
export function VehicleButton({
  label,
  testId,
  onClick,
  isHidden,
  icon,
  isSuccess,
  hasError,
}: {
  label: string;
  testId?: string;
  onClick: () => void;
  isHidden: boolean;
  icon?: React.ReactNode;
  isSuccess?: boolean;
  hasError?: boolean;
}) {
  testId = testId ?? `seller-vehicle-${label.toLowerCase().replace(' ', '-')}-button`;
  if (isHidden) return null;
  return (
    <Button
      data-testid={testId}
      onClick={onClick}
      className={'bg-grey-50 normal-case !rounded-none border-b border-grey-200 w-full p-5 text-dark-primary flex justify-between font-semibold text-lg'}
    >
      <div className="flex gap-3 items-center">
        {icon ? icon : null}
        <p className="mr-2">{label}</p>
        {isSuccess ? (
          <SuccessIcon className="mt-1 w-5 h-5" />
        ) : hasError ? (
          <InfoErrorIcon className="mt-1 w-5 h-5" />
        ) : null}
      </div>
      <LeftIcon />
    </Button>
  );
}

